<div style="margin-top: 20px"></div>


<div style="padding: 10px 10px;">
    <dx-toolbar style="padding-right: 30px;">
        <dxi-item name="groupPanel"></dxi-item>
        <dxi-item location="after">            
            <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
            (onClick)="exportExcel($event)" [disabled]="childDataGrids.length == 0">
            </dx-button>
        </dxi-item>
        <dxi-item name="searchPanel"></dxi-item>
    </dx-toolbar>

    <div style="margin-top: 10px"></div>
    
    <div>
        <dx-tab-panel
            #crmChildTabPanel
            [height]="'auto'"  
            [selectedIndex]="0"
            [loop]="false"
            [animationEnabled]="false"
            [swipeEnabled]="false"
            [deferRendering]="false"
            [visible]="true">
        
            <dxi-item [title]="'Prospect List'">
                <div class="heading-box">                    
                    <h4 class="heading">{{crmProspectsw91MA_heading1}}</h4>                    
                </div>
                <app-crm-report-datagrid 
                    [reportRequest]="reportRequest" 
                    [reportType]="'CRM_Prospects_With91MA'"
                    (dataGridCreated)="onDataGridCreated($event)">
                </app-crm-report-datagrid>  
            </dxi-item>                    
        </dx-tab-panel>
    </div>
</div>
